<template>
  <el-dialog
    top="15vh"
    class="device-edit__dialog"
    :title="row.id ? $t('Common.edit') : $t('Common.create')"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('Device.productName')" prop="productKey">
        <Select
          :options="productList"
          v-model="form.productKey"
          :placeholder="$t('Device.productName')"
          :disabled="!!row.id"
          @getRaw="handleProductChange"
        >
        </Select>
      </el-form-item>
      <el-form-item :label="$t('Device.deviceCode')" prop="code">
        <el-input v-model="form.code" :placeholder="$t('Device.deviceCode')" :maxlength="32">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('Device.factoryArea')" prop="factoryArea">
        <el-input v-model="form.factoryArea" :placeholder="$t('Device.factoryArea')"> </el-input>
      </el-form-item>
      <el-form-item :label="$t('Device.MAC')" prop="mac">
        <el-input v-model="form.mac" :placeholder="$t('Device.MAC')" :maxlength="32"> </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
  </el-dialog>
</template>

<script>
import Select from '@/components/CommonForm/Select'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    Select
  },
  data() {
    return {
      form: {},
      productList: [],
      rules: {
        // name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        code: [{ required: true, message: this.$t('Device.deviceCode'), trigger: 'blur' }],
        factoryArea: [{ required: true, message: this.$t('Device.factoryArea'), trigger: 'blur' }],
        mac: [{ required: true, message: this.$t('Device.MAC'), trigger: 'mac' }],
        productKey: [{ required: true, message: this.$t('Device.productModel'), trigger: 'change' }]
      },
      loading: false
    }
  },
  created() {
    this.getProductIds()
    if (this.row.id) {
      this.form = {
        ...this.row
      }
    }
  },
  methods: {
    //获取产品下拉框列表
    getProductIds() {
      let params = {
        type: 'refrigerator'
      }
      if (this.row.id) {
        this.$ajax.get(this.$api.product.product_select, params).then((res) => {
          this.productList = res.data
        })
      } else {
        params.status = 'ENABLE'
        this.$ajax.get(this.$api.product.product_select, params).then((res) => {
          this.productList = res.data
        })
      }
    },
    close() {
      this.$emit('update:visible', false)
    },
    handleProductChange(product) {
      this.form.productName = product.name
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let params = {
        id: this.row.id,
        code: this.form.code,
        mac: this.form.mac,
        factoryArea: this.form.factoryArea,
        productKey: this.form.productKey
      }
      let api = this.row.id
        ? this.$api.iceDevice.iceDevice_unInstall_update
        : this.$api.iceDevice.iceDevice_unInstall_add
      this.$ajax
        .post(api, params)
        .then(() => {
          this.$message.success(
            `${this.row.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`
          )
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.device-edit__dialog {
  /deep/ {
    .el-dialog__body {
      padding-left: 40px;
    }
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
}
</style>
